export const AR = {
    Interno:{
        Principal:"أهلاً وسهلاً",
        CerrarSesion:"تسجيل الخروج",
        Menu:{
            OrdenCompra:"أمر الشراء",
            SolCambioCuenta:"طلب تغيير الحساب البنكي",
            Trabajadores:"العمال",
            Admin:"الإدارة",
            istracion:"",
            InvitacionProveedores:"دعوة الموردين"
        },
        OCDocPendiente:{
            Titulo:"أمر الشراء",
            ComoCargo:"كيف أحمّل فاتورتي؟",
            BuscarOC:"البحث عن أمر الشراء غير الموجود",
            OC:"أ.ش",
            Contrato:"عقد",
            FechaOC:"تاريخ أ.ش",
            PorEnviar:"قيد الإرسال",
            Certificados:"الشهادات",
            Soportes:"الدعم",
            Facturas:"الفواتير",
            Accion:"الإجراء",
            RFCRecept:"RFC المستقبل:",
            Moneda:"العملة",
            FechaReqSitio:"تاريخ الطلب في الموقع",
            Subtotal:"المجموع الفرعي",
            Comprador:"المشتري",
            Impuestos:"الضرائب",
            Activador:"المُفعِّل",
            Retenidos:"المحتجزة",
            Total:"الإجمالي",
            HeaderFacturasTutorial:"كيف أحمّل فاتورتي؟",
            Tutorial_Paso1Titulo:"1.- أوامر الشراء",
            Tutorial_Paso1Desc:'ابحث عن أمر الشراء واختر خيار "الفواتير" من القائمة المنسدلة في عمود الإجراء',
            Tutorial_Paso2Titulo:"2.- اختيار البند",
            Tutorial_Paso2Desc:"قم بتحميل الفاتورة للبند المعني.",
            Tutorial_Paso3Titulo:"3.- تحميل الفاتورة",
            Tutorial_Step1:"حدد الإدخالات لحساب مبلغ الفاتورة (في حالة استلام مواد).",
            Tutorial_Step2:"قم بتحميل ملف .xml (ينطبق فقط على الموردين المكسيكيين).",
            Tutorial_Step3:"قم بتحميل ملف .pdf.",
            Tutorial_Step4:"راجع مبالغ الفاتورة.",
            Tutorial_Step5:"اضغط زر الإرسال.",
            Tutorial_BtnVideo:"مشاهدة الفيديو التعليمي",
            Tutorial_BtnCerrar:"إغلاق",
            HeaderBuscarOC:"البحث عن أوامر الشراء",
            BuscarOCInstruccion:"أدخل أمر الشراء لمعرفة سبب عدم ظهوره في القائمة.",
            BuscarOCLabel:"أمر الشراء:",
            BuscarOCBtn:"بحث",
            Concepto:"المفهوم",
            MontoConImpuestos:"المبلغ مع<br>الضرائب",
            TotalRemision:"إجمالي<br>الحوالة",
            Facturado:"مُفوتَر",
            PorFacturar:"قيد الفوترة",
            Factura:"فاتورة",
            Subir:"رفع"
        },
        EnvioFacturas:{
            Titulo:"إرسال الفواتير",
            OrdenCompra:"أمر الشراء",
            Moneda:"العملة",
            FechaReqSitio:"تاريخ الطلب في الموقع",
            Subtotal:"المجموع الفرعي",
            Comprador:"المشتري",
            Impuestos:"الضرائب",
            Total:"الإجمالي",
            Concepto:"البند",
            Monto:"المبلغ",
            Facturado:"مفوتر",
            PorFacturar:"قيد الفوترة",
            Factura:"فاتورة",
            TotalesConImpuesto:"الإجماليات مع الضريبة",
            Subir:"تحميل",
            ArchivoXML:"ملف XML",
            ArchivoPDF:"ملف PDF",
            NumFactura:"رقم الفاتورة",
            Impuesto:"الضريبة",
            FechaFactura:"تاريخ الفاتورة",
            TotalFactura:"إجمالي الفاتورة",
            Referencia:"المرجع",
            Comentarios:"التعليقات",
            BtnCancelar:"إلغاء",
            BtnEnviar:"إرسال"
        },
        CambioCuentaBancaria:{
            Titulo:"طلب تغيير الحساب البنكي",
            Motivo:"سبب تغيير الحساب البنكي:",
            MotivoPH:"السبب",
            ModalAvisoP1:"يتطلب طلب تغيير الحساب إرسال الوثائق المطلوبة وسيُرسل إلى أرندال للموافقة عليه.",
            ModalAvisoP2:"سنتواصل مع الممثل القانوني للشركة للتحقق من المعلومات.",
            BtnProceder:"متابعة",
            ModalEnProcesoTitulo:"الطلب قيد المعالجة",
            ModalEnProceso:"يوجد بالفعل طلب تغيير حساب بنكي هذا الشهر، يرجى انتظار الرد.",
            BtnRegresar:"رجوع",
            Reemplazar:"استبدال"
        },
        InvitacionProveedores:{
            Titulo:"دعوة الموردين",
            Estatus:"الحالة",
            VerSoloBtnText:"عرض دعواتي فقط",
            BtnInvitar:"دعوة",
            FechaInvitacion:"تاريخ الدعوة",
            FechaEstatus:"تاريخ الحالة",
            Proveedor:"المورد",
            Contacto:"جهة الاتصال",
            CorreoContacto:"بريد جهة الاتصال",
            InvitadoPor:"مدعو من قِبَل",
            ColEnviar:"إرسال",
            ColCancelar:"إلغاء",
            ModalTitulo:"دعوة مورد",
            TipoProveedor:"نوع المورد",
            TipoPersona:"نوع الشخص",
            SolicitarSubcontratos:"طلب وثائق إضافية للمقاولين من الباطن.",
            Proyecto:"المشروع",
            Pais:"البلد",
            RazonSocial:"الاسم الرسمي",
            RazonSocialPH:"الاسم التجاري الرسمي",
            NomCom:"الاسم التجاري",
            NomComPH:"الاسم التجاري",
            DiasPlazo:"أيام الاستحقاق",
            DiasPlazoHint:"أيام الاستحقاق",
            ProveedorBuscarPH:"اكتب 5 أحرف للبحث عن المورد...",
            SeccionContacto:"جهة الاتصال",
            Nombres:"الأسماء",
            NombresPH:"الأسماء",
            Apellidos:"الأسماء العائلية",
            ApPaternoPH:"الاسم العائلي الأول",
            ApMaternoPH:"الاسم العائلي الثاني",
            Puesto:"المنصب",
            PuestoPH:"المنصب",
            CorreoLabel:"البريد الإلكتروني",
            CorreoPH:"بريد@شركة.com",
            Telefono:"الهاتف",
            ComentariosInvitacion:"تعليقات الدعوة",
            BtnCancelar:"إلغاء",
            BtnEnviarInvitacion:"إرسال الدعوة"
        },
        OrdenCompra:{
            a:""
        },
        Trabajadores:{
            a:""
        }
    },
    Externo:{
        Login:{
            TituloLogin:"تسجيل الدخول بالبريد الإلكتروني المسجل",
            CorreoHint:"البريد الإلكتروني",
            ContrasenaHint:"كلمة المرور",
            BtnLogin:"دخول",
            RecordarContrasena:"تذكر كلمة المرور",
            OlvideContrasena:"نسيت كلمة المرور",
            BtnRegistro:"تسجيل بريدي الإلكتروني (أنا بالفعل مورد لأرندال)",
            Notify:{
                IntentosExcedidos:"تم تجاوز عدد المحاولات المسموح بها (5)، حاول مرة أخرى بعد دقيقة على الأقل.",
                TerminoTiempoEspera:"انتهت مهلة الانتظار، حاول مرة أخرى.",
                NecesarioCorreoContrasena:"يجب إدخال البريد الإلكتروني وكلمة المرور."
            }
        },
        RegistroProveedor:{
            msgProveedorRegistrado:"بيانات المورد مسجلة بالفعل.",
            msgInvitacionNoEncontrada:"لم يتم العثور على الدعوة أو تم حذفها.",
            Titulo:"بيانات المورد",
            TituloRegistrado:"تم تسجيل البيانات بنجاح.",
            msgTituloRegistrado:"تم تسجيل البيانات بنجاح، يرجى انتظار الموافقة على التسجيل، يمكنك إغلاق هذه النافذة.",
            PaisOrigen:"بلد المنشأ",
            RFCTAX:"RFC / Tax ID",
            NomComercial:"الاسم التجاري",
            NomComercialHint:"الاسم التجاري",
            RazonSocial:"الاسم التجاري الرسمي",
            RazonSocialHint:"الاسم التجاري الرسمي",
            TipoEmpresa:"نوع الشركة",
            PersonaMoral:"شركة",
            PersonaFisica:"شخص طبيعي",
            DiasPlazo:"أيام الاستحقاق",
            ContactoArendal:"جهة الاتصال في أرندال",
            ContactoArendalHint:"مجموعة المشتريات",
            tabDocumentacion:"الوثائق",
            tabDireccion:"العنوان",
            tabDatosContacto:"بيانات الاتصال",
            tabCuentaBancaria:"الحساب البنكي",
            tbDocumento:"الوثيقة",
            tbDescripcion:"الوصف",
            tbArchivo:"الملف (PDF/JPG/PNG/DOC/DOCX)",
            tbSubir:"تحميل",
            CalleNumero:"الشارع والرقم",
            CalleNumeroHint:"الشارع والرقم",
            Colonia:"الحي",
            ColoniaHint:"الحي",
            CP:"الرمز البريدي",
            CPHint:"الرمز البريدي",
            Ciudad:"المدينة",
            CiudadHint:"المدينة",
            Estado:"المنطقة",
            EstadoHint:"المنطقة",
            Nombres:"الأسماء",
            NombresHint:"الأسماء",
            PaternoHint:"الاسم العائلي الأول",
            MaternoHint:"الاسم العائلي الثاني",
            Puesto:"المنصب",
            PuestoHint:"المنصب",
            Correo:"البريد الإلكتروني",
            CorreoHint:"البريد الإلكتروني",
            Telefono:"الهاتف",
            TelefonoHint:"الهاتف",
            Direccion:"العنوان",
            DireccionHint:"العنوان",
            Moneda:"العملة",
            Banco:"البنك",
            BancoHint:"البنك",
            NumCuenta:"رقم الحساب",
            NumCuentaHint:"رقم الحساب",
            Titular:"صاحب الحساب",
            TitularHint:"صاحب الحساب",
            ABA:"ABA",
            ABAHint:"ABA",
            SwiftCode:"Swift Code",
            SwiftCodeHint:"Swift Code",
            BtnGuardarEnviar:"حفظ وإرسال",
            Notify:{
                ExtencionIncorrecta:"يرجى اختيار ملف pdf أو jpg أو png أو doc أو docx.",
                ArchivoExistente:"يوجد بالفعل ملف تم اختياره مسبقاً، يرجى اختيار ملف آخر.",
                ValidacionSwiftCode:"يرجى إدخال رمز SWIFT.",
                ValidacionABA:"يرجى إدخال رمز ABA.",
                ValidacionTitular:"يرجى إدخال صاحب الحساب.",
                ValidacionNoCuenta:"يرجى إدخال رقم الحساب.",
                ValidacionBanco:"يرجى إدخال اسم البنك.",
                ValidacionMoneda:"يرجى إدخال العملة.",
                ValidacionDireccion:"يرجى إدخال عنوان جهة الاتصال.",
                ValidacionTelefono:"يرجى إدخال رقم هاتف جهة الاتصال.",
                ValidacionCorreo:"لم يُعثر على بريد جهة الاتصال، يرجى التواصل مع المسؤول.",
                ValidacionPuesto:"يرجى إدخال منصب جهة الاتصال.",
                ValidacionApellidoM:"يرجى إدخال الاسم العائلي الثاني لجهة الاتصال.",
                ValidacionApellidoP:"يرجى إدخال الاسم العائلي الأول لجهة الاتصال.",
                ValidacionNombres:"يرجى إدخال اسم(أسماء) جهة الاتصال.",
                ValidacionEstado:"يرجى إدخال المنطقة.",
                ValidacionCiudad:"يرجى إدخال المدينة.",
                ValidacionCP:"يرجى إدخال الرمز البريدي.",
                ValidacionColonia:"يرجى إدخال الحي.",
                ValidacionCalleNumero:"يرجى إدخال الشارع والرقم.",
                ValidacionDiasPlazo:"يرجى إدخال أيام الاستحقاق.",
                ValidacionRazonSocial:"يرجى إدخال الاسم التجاري الرسمي.",
                ValidacionNomComercial:"يرجى إدخال الاسم التجاري.",
                ValidacionRFC:"يرجى إدخال RFC / Tax ID.",
                ValidacionPais:"يرجى اختيار البلد.",
                ValidacionDocumentos:"يرجى تحميل الوثائق المفقودة.",
                ErrorPeticion:"حدث خطأ غير متوقع، يرجى التواصل مع المسؤول.",
                ErrorToken:"عذراً، لم يُعثر على رمز صالح."
            }
        }
    }
};
